// Cross-layout signal for whether the EnvBanner is currently rendered
// and which edge it's anchored to. PrivateAppShell (which owns the
// banner) publishes the placement via a `$effect`; the root +layout
// reads it to position the ToastDock so toasts always clear the
// banner — currently the banner sits at the bottom, but the same
// signal handles a future move to the top without any code change at
// the dock site.
//
// The banner's footprint is `min-h-8 leading-none py-[6px]` → 32px
// across every supported breakpoint (content never wraps and never
// sizes above 32px). Consumers that offset around it (e.g. the
// ToastDock) hardcode the derived offset; if the banner grows a
// taller variant, hunt down those literals.

export type EnvBannerPlacement = 'top' | 'bottom';

type EnvBannerState = {
	placement: EnvBannerPlacement | null;
};

export const envBanner = $state<EnvBannerState>({ placement: null });
